export class EmailHelper {
  static getEmailDomain = (email: string): string => {
    return email.replace(/.*@/, '');
  };
}
